import { useSelector } from "react-redux";
import { FlightFareGridItem } from "@tenant/flights";
import clsx from "clsx";
import defaultStyles from "./PackageFlightFareGridItem.module.scss";
import { getPackageFarePrice } from "@/modules/packages/utilities/packageFarePrice";
import { useIsPackageIncrementalPricing } from "@/pages/Packages/hooks";
import {
  PackageFlightSelectors,
  PackageSearchSelectors,
} from "@/store/packages/selectors";

/**
 * RBC Package Flight Fare Grid Item
 *
 * This component wraps the core FlightFareGridItem to provide
 * RBC-specific package pricing for fare grid items.
 */
export const PackageFlightFareGridItem = (
  flightProps: React.ComponentProps<typeof FlightFareGridItem>
) => {
  const packageStateByFareId = useSelector(
    PackageFlightSelectors.getPackageStateByFareId
  );

  const packageType = useSelector(
    PackageSearchSelectors.getSearchFormPackageType
  );

  const isIncrementalPricing = useIsPackageIncrementalPricing();

  const fareId = flightProps.fare?.fareId;
  const packagePrice = getPackageFarePrice(
    fareId ? packageStateByFareId?.[fareId] : undefined,
    packageType
  );

  const packageProps: React.ComponentProps<typeof FlightFareGridItem> = {
    ...flightProps,
    fare: {
      ...flightProps.fare,
      price: packagePrice,
    },
  };

  return (
    <FlightFareGridItem
      {...packageProps}
      className={clsx(
        packageProps.className,
        defaultStyles.packageFlightFareGridItem
      )}
      fareFormatOptions={
        isIncrementalPricing ? { signDisplay: "always" } : undefined
      }
    />
  );
};
